import React, { useState } from 'react';
import { FaRegHandshake, FaTruck, FaUndo } from 'react-icons/fa'; // React icons

function ExchangeReturn() {
  const [activeAccordion, setActiveAccordion] = useState([]);

  const toggleAccordion = (section) => {
    if (activeAccordion.includes(section)) {
      setActiveAccordion(activeAccordion.filter((item) => item !== section));
    } else {
      setActiveAccordion([...activeAccordion, section]);
    }
  };

  return (
    <div className="px-6 py-8 md:px-16 lg:px-32 font-serif">
      {/* Top Heading */}
      <h1 className="text-2xl md:text-4xl font-bold text-center mb-8 text-[#FF4902]">
        Return, Exchange & Cancellation
      </h1>

      {/* Main Content */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-20">
        {/* Left Section */}
        <div>
          <p className="mb-4 text-lg leading-relaxed">
            Mammoth Streetwears is Clothing made in India Brand.
          </p>
          <p className="mb-4 text-lg leading-relaxed">
            Mammoth is a made-to-order brand, focusing on a variety of products and techniques.
          </p>
          <p className="mb-4 text-lg leading-relaxed">
            Many of our designs are handmade, and we also incorporate upcycled materials.
          </p>
          <p className="mb-8 text-lg leading-relaxed">
            This approach allows for variations and ensures uniqueness in every item that we ship out!
          </p>

          <h2 className="text-2xl font-bold mb-4">Avoid Hassle of Exchange & Return</h2>
          <p className="mb-8 text-lg leading-relaxed">
            Reach us prior for a fit assist and get all your doubts cleared. Drop us a message and receive a callback.
          </p>

          {/* Icons with Headings */}
          <div className="space-y-12">
            <div className="text-center">
              <FaUndo className="text-5xl text-[#FF4902] mx-auto mb-4" />
              <h3 className="font-semibold text-xl">100% Refund on Damages</h3>
              <p className="text-gray-600">Quick and hassle-free refunds for quality issues or wrong delivery.</p>
            </div>

            <div className="text-center">
              <FaTruck className="text-5xl text-[#FF4902] mx-auto mb-4" />
              <h3 className="font-semibold text-xl">Priority Delivery</h3>
              <p className="text-gray-600">Get your orders delivered quickly with our priority shipping options.</p>
            </div>

            <div className="text-center">
              <FaRegHandshake className="text-5xl text-[#FF4902] mx-auto mb-4" />
              <h3 className="font-semibold text-xl">Free Exchange</h3>
              <p className="text-gray-600">Enjoy free exchanges on any size issues within terms.</p>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="p-6 bg-gray-50 shadow-lg rounded-lg">
          <h2 className="text-xl font-bold mb-4">Refund, Sales, Partial COD</h2>

          {/* Accordion Sections */}
          {[
            'Refund',
            'Exchange',
            'Return & Exchange',
            'Cancellation',
            'Sale Items',
            'Contact Us',
          ].map((section, index) => (
            <div key={index} className="mb-6">
              <button
                onClick={() => toggleAccordion(section)}
                className="w-full text-left px-4 py-2 bg-[#FDE4D9] rounded-md font-medium text-gray-800 focus:outline-none"
              >
                {section}
                <span className="float-right">
                  {activeAccordion.includes(section) ? '▲' : '▼'}
                </span>
              </button>
              {activeAccordion.includes(section) && (
                <div className="mt-2 px-4 text-gray-700">
                  {section === 'Refund' && (
                    <ul className="list-disc ml-6">
                      <li>100% refund for quality issues, damages, or wrong delivery.</li>
                      <li>No refunds available on sale items, customized items, or bulk orders.</li>
                      <li>Free exchanges or store credits available.</li>
                    </ul>
                  )}
                  {section === 'Exchange' && (
                    <ul className="list-disc ml-6">
                      <li>Free exchanges for size issues.</li>
                      <li>No exchanges for customized or POD (Print on Demand) items.</li>
                      <li>Make an unboxing video for any damage caused during delivery.</li>
                    </ul>
                  )}
                  {section === 'Return & Exchange' && (
                    <p>Details about return and exchange policies will go here.</p>
                  )}
                  {section === 'Cancellation' && (
                    <ul className="list-disc ml-6">
                      <li>Orders can be cancelled within 60 minutes for a full refund.</li>
                      <li>For in-transit products, store credits are issued for future purchases.</li>
                    </ul>
                  )}
                  {section === 'Sale Items' && (
                    <p>Sale items are non-refundable and non-returnable. Sizing exchanges may be provided case by case.</p>
                  )}
                  {section === 'Contact Us' && (
                    <p>Please feel free to contact us during office hours for grievances or further assistance.</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExchangeReturn;
